import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthErrorPage as FoundationAuthErrorPage } from '@foundation-bb/foundation-auth-ui';
import { button } from '@/ui/Button/Button.css';
import * as layout from '@/styles/layout.css';
import * as s from './AuthErrorPage.css';

// Lands here when the API rejects an auth token (magic-link expired/used/malformed,
// SSO failure, etc.): the API redirects the browser to /auth/error?code=<code>.
// Foundation's AuthErrorPage maps the code to a localized message via
// authErrorMessageKey and renders a danger alert (role="alert", data-tone="danger")
// + the rys-styled back link.
export default function AuthErrorPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const code = params.get('code');

  return (
    <div className={layout.centerBoth} style={{ minHeight: '100vh' }}>
      <FoundationAuthErrorPage
        code={code}
        t={t}
        labels={{
          title: t('authError.title'),
          backToSignIn: t('authError.backToSignIn'),
        }}
        renderBackLink={(label) => (
          <Link to="/" className={button({ variant: 'primary' })}>{label}</Link>
        )}
        classNames={{ box: s.box, title: s.title, alertWrap: s.alertWrap }}
      />
    </div>
  );
}
